import React, { useEffect, useState } from "react"
import { useAuth } from "../../../context/AuthContext"
import toast from "react-hot-toast";
import { InverntroyService } from "../../../services/api/inventroy.service"
import { DataTable } from "../../DataTable/DataTable"

export const InwardStockTable = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [stockList, setStockList] = useState<any[]>([]);

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [nextPage, setNextPage] = useState<number | null>(null);
  const [previousPage, setPreviousPage] = useState<number | null>(null);

  const { user } = useAuth();

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        if (!user?.id) {
          toast.error("Clinic ID is missing.");
          return;
        }
        const stocks = await InverntroyService.getInwardStockListingForClinic({
          clinicId: user.id,
          page: currentPage,
          pageSize,
        });
        if (stocks?.success) {
         setStockList(stocks?.data.StockData);
          setCurrentPage(stocks?.data.pagination?.currentPage);
          setTotalPages(stocks?.data.pagination?.totalPages);
          setNextPage(stocks?.data.pagination?.nextPage);
          setPreviousPage(stocks?.data.pagination?.previousPage);
        }
      } catch (error) {
        toast.error(`${error}`);
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
  }, [currentPage, pageSize, user?.id]);

  const columns = [
    {
      key: "productName",
      title: "Product Name",
      width: "w-[240px]",
      render: (item) => (
        <div className="flex items-center space-x-3">
          <img
            src={item.productImage}
            alt={item.productName}
            className="w-12 h-12 rounded-lg object-cover border border-gray-200"
          />
          <div
            className="text-sm font-medium line-clamp-2 cursor-default"
            title={item.productName}
          >
            {item.productName}
          </div>
        </div>
      ),
    },
    {
      key: "wholesalerName",
      title: "Wholesaler Name",
      width: "w-[200px]",
      render: (item) => (
        <div className="text-sm font-medium">{item.wholesalerName}</div>
      ),
    },
    {
      key: "categoryName",
      title: "Product Category",
      width: "w-[200px]",
      render: (item) => (
        <div className="text-sm font-medium">{item.categoryName}</div>
      ),
    },
    {
      key: "invoiceNumber",
      title: "Invoice No",
      width: "w-[160px]",
      render: (item) => (
        <div className="text-sm font-medium">{item.invoiceNumber}</div>
      ),
    },
    {
      key: "invoiceDate",
      title: "Invoice Date",
      width: "w-[180px]",
      render: (item) => {
        const date = new Date(item.invoiceDate);
        const formatted = `${date
          .getDate()
          .toString()
          .padStart(2, "0")} ${date.toLocaleString("default", {
          month: "short",
        })} ${date.getFullYear()}`;
        return <div className="text-sm font-medium">{formatted}</div>;
      },
    },
    {
      key: "invoiceAmount",
      title: "Invoice Amount",
      width: "w-[160px]",
      render: (item) => (
        <div className="text-sm font-medium">₹ {item.invoiceAmount}</div>
      ),
    },
    {
      key: "manufacturerName",
      title: "Manufacturer Name",
      width: "w-[200px]",
      render: (item) => (
        <div className="text-sm font-medium">{item.manufacturerName}</div>
      ),
    },
    {
      key: "hsnNumber",
      title: "HSN Number",
      width: "w-[160px]",
      render: (item) => (
        <div className="text-sm font-medium">{item.hsnNumber}</div>
      ),
    },
    {
      key: "landingCost",
      title: "Landing Cost",
      width: "w-[160px]",
      render: (item) => (
        <div className="text-sm font-medium">₹ {Number(item.landingCost).toFixed(2)}</div>
      ),
    },
  ];

  return (
    <div className="relative bg-white my-4 pt-4 rounded-md">
      <h3 className="text-lg font-medium px-4">Inward Stocks List</h3>
      <DataTable
        data={stockList}
        columns={columns}
        itemsPerPage={10}
        isLoading={isLoading}
        pagination={{
          currentPage,
          setCurrentPage,
          setTotalPages,
          totalPages,
          pageSize,
          setPageSize,
          // nextPage,
          // previousPage,
        }}
      />
    </div>
  );
};